import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import styles from './styles.module.scss';

export default function TwoColContentBehavior({ global, title, text, items }) {
  return (
    <section className={`${styles.root}`}>
      <Container>
        <header className="text-center mb-4">
          {title}
          {text}
        </header>
        {items && items.length > 0 && (
          <div className={`${styles.gridContainer} row`}>
            {items.map((item, index) => (
              <div
                className={`${styles.gridItem} col-md-4 d-flex flex-column align-items-stretch`}
                key={index}
              >
                {item?.image ? (
                  <figure className="d-flex justify-content-center align-items-center">
                    <SourceFlowImage
                      src={
                        item?.image
                          ? item.image
                          : "/site-assets/placeholders/img-placeholder.jpg"
                      }
                      size="1000x"
                      alt={`${item?.id}`}
                      className="w-50"
                    />
                  </figure>
                ) : (
                  ""
                )}
                <article className="my-4 px-4 flex-grow-1">
                  <span
                    dangerouslySetInnerHTML={{ __html: item.text ?? null }}
                  />
                  <span  className="h3" style={{color: `${item.title_color}`}}
                    dangerouslySetInnerHTML={{ __html: item.title ?? null }}
                  />
                  <span
                    dangerouslySetInnerHTML={{ __html: item.content ?? null }}
                  />
                </article>
              </div>
            ))}
          </div>
        )}
      </Container>
    </section>
  );

}